/** 肛了么 landing — product links & constants. */

export const SITE_NAME = "肛了么";
export const SITE_TAGLINE = "用全屏倒计时给久坐一个明确的结束点";

export const GITHUB_REPO_URL = "https://github.com/wu-clan/kegel-reminder";
export const SPONSOR_URL = "https://wu-clan.github.io/sponsor/";
export const QQ_CHANNEL_URL = "https://pd.qq.com/s/ckdyhy4vy?b=5";
export const SITE_URL = "https://kegel-reminder.wu-clan.cc";
export const PURCHASE_PATH = "/purchase/";

/** Same-origin first (Cloudflare Pages Function), then production. */
export const RELEASE_MANIFEST_CANDIDATES = [
  "/api/latest",
  `${SITE_URL}/api/latest`,
] as const;

export const FALLBACK_DOWNLOAD_BASE_URL = "https://kegel-reminder-downloads.wu-clan.cc";
export const LEGACY_DOWNLOAD_BASE_URL =
  "https://pub-7bfc012d55b349fba6968555e34d5894.r2.dev";
